import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';
import { addCommonParams } from '@/pages/agency/growup/dashboard/api';

const DEFAULT_CACHE = 1000 * 60 * 60;

export const getSummaryReport = (data: any) => {
  return Promise.resolve({
    code: 0,
    data: {
      partition_time: '',
    },
  });
  const url = getAgpApiUrl('eservice/grow_up_center', 'get_agent_group');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};
